import Factory from "@/schemas/factory";

const schema = new Factory()
    .hasId()
    .hasName()
    .publishable()
    .hasTimestamps()
    .make();

schema.prop('lookupKey').setType(String);

export default schema;
